import { useMemo } from "react";
import AdminTable from "./AdminTable";
import { useHistory } from "react-router-dom";
import { Typography } from "@material-ui/core";
import { deleteIrrigatorType, IrrigatorType } from "../../../api/irrigators";
import { UserState } from "../../../context/auth";

export default function IrrigatorTypesTable({
  user,
  data,
  onRefresh,
}: {
  user: UserState;
  data: IrrigatorType[] | undefined;
  onRefresh: () => void;
}) {
  const history = useHistory();

  const config = useMemo(
    () => ({
      columns: [
        {
          title: "Name",
          field: "name",
        },
      ],
      data: data,
      options: { pageSizeOptions: [5, 10, 20, 50] },
    }),
    [data]
  );

  // const history = useHistory();
  const onCreate = () => history.push("/admin/irrigator-type");
  const onEdit = (id: number) => history.push(`/admin/irrigator-type/${id}`);
  const onDelete = async (record: IrrigatorType) => {
    if (!user.token) return;
    return (await deleteIrrigatorType(user.token, record.id)).data;
  };

  return (
    <AdminTable
      title={<Typography variant="h2">Irrigator Types</Typography>}
      type="irrigator type"
      config={config}
      onRefresh={onRefresh}
      onCreate={onCreate}
      onEdit={onEdit}
      onDelete={onDelete}
      deleteLabel="name"
    />
  );
}
